import React, {useMemo} from 'react'
import {useTranslation} from 'i18n'
import TemplateTransactionHistoryContentItemCommon from './TemplateTransactionHistoryContentItemCommon'
import {TemplateTransactionHistoryContentItemProps} from './TemplateTransactionHistoryContentItemProps'

export default function TemplateTransactionHistoryContentItem({
  data,
  onClickItem,
}: TemplateTransactionHistoryContentItemProps) {
  const {
    transaction_type: type,
    creator,
    bank_name,
    collector_nickname,
    amount,
    status,
    transaction_date,
    is_free_first_buy,
    count_completed_invoices,
    count_waiting_hires_invoices,
  } = data
  const {translate} = useTranslation()

  const transaction_partner = useMemo(() => {
    if (type === 'Incentive') return translate('global:fotoyu')
    if (creator && (type === 'Purchase' || type === 'Refund'))
      return creator.length > 1
        ? `${creator.length} ${translate('global:creators')}`
        : creator[0]
    if (type === 'Received' || type === 'Refund_to') return collector_nickname
    if (type === 'Withdraw') return bank_name
    return ''
  }, [bank_name, collector_nickname, creator, translate, type])

  return (
    <TemplateTransactionHistoryContentItemCommon
      data={{
        amount,
        transaction_date,
        transaction_partner,
        transaction_type: type,
        is_free_first_buy,
        status,
        count_completed_invoices,
        count_waiting_hires_invoices,
      }}
      onClickItem={onClickItem}
    />
  )
}
